import styled from 'styled-components';
import { H1, SectionParent } from '../../StyledComponents';

import React from 'react';
import { StaticQuery, graphql, Link } from 'gatsby';
import Image from 'gatsby-image';
import RequestDemoForm from './RequestDemoForm';
import Check from '../../../assets/v2/signup/check.svg';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-image: linear-gradient(to bottom, #fafbfe 0%, #fafbfe 99%);
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  margin-top: 6rem !important;
  padding-top: 5rem !important;
  text-align: center;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1000px) {
    min-height: 200px;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
  align-content: center;
`;

const SectionThree = styled(SectionParent)`
  padding-top: 5rem !important;
  padding-bottom: 5rem !important;
  font-size: 14px;
  text-align: center;
`;

const SectionTwo = styled(SectionParent)`
  background-repeat: no-repeat;
  /* padding-top: 6rem !important; */
  padding-bottom: 2rem;
  padding-top: 3rem !important;
  text-align: center;
  align-content: center;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 0rem !important;
  }
  @media (min-width: 1681px) {
    padding-bottom: 8rem;
  }
  width: 100%;
  display: grid;
  grid-gap: 58px 0rem;
`;

const SectionOneTitle = styled.div`
  font-weight: 500;
  font-size: 44px;
  color: #fff;
  margin-left: 3rem;

  @media (max-width: 1680px) {
    font-size: 48px;
  }
  @media (max-width: 1024px) {
    font-size: 36px;
  }
  @media (max-width: 768px) {
    text-align: center;
    margin-top: 1rem;
  }
  @media (max-width: 520px) {
    text-align: center;
    font-size: 28px;
    margin-left: 0;
  }
`;

const HeroTitle = styled(H1)`
  margin-left: 2rem;
  color: #151828;
  @media (min-width: 1280px) {
    font-size: 26px;
  }
  width: 50%;
  text-align: left;
  @media (max-width: 1280px) {
    width: 40%;
  }
  @media (max-width: 1000px) {
    width: 100%;
    text-align: center;
  }
  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
  }
  @media (max-width: 520px) {
    font-size: 21px;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 1rem;
  margin-left: 2rem;
  width: 50%;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16.5px;
  font-weight: normal;
  text-align: left;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #151828;
  @media (max-width: 1280px) {
    width: 40%;
  }
  @media (max-width: 768px) {
    text-align: center;
    width: 80%;
    margin-left: 0rem;
    font-size: 15px;
    margin-bottom: 1rem;
  }

  @media (max-width: 1000px) {
    width: 100%;
    text-align: center;
  }

  @media (min-width: 1500px) {
    width: 45%;
  }
`;

const FormComponentList = styled.ul`
  margin-left: 20px;
  padding-left: 0.5em;
  list-style: none;
  margin-top: 1rem;
  @media (max-width: 768px) {
    // display: none;
    margin: 0 auto;
  }
  @media (min-width: 1401px) {
    width: 130%;
  }
`;

const FormComponentListItem = styled.li`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  text-align: left;
  @media (max-width: 1024px) {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    font-size: 15px;
  }
  @media (max-width: 320px) {
    font-size: 14px;
  }
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.94;
  letter-spacing: normal;
  color: #151828;
  background: url(${Check}) no-repeat;
  padding: 0.3em 0px 0.1em 30px;
  background-size: 18px;
  background-position-y: center;
`;

const ItemContainer = styled.div`
  border-radius: 32.5px;
  border: solid 1px #d7dce2;
  display: grid;
  align-items: center;
  width: 50%;
  height: 50%;
  margin-top: 1rem;
  @media (max-width: 1280px) {
    width: 40%;
  }
  margin-left: 1rem;
  grid-template-columns: 78px auto;
  grid-gap: 35px;

  @media (max-width: 1000px) {
    width: 100%;
    justify-self: center;
    grid-template-columns: auto;
    margin-left: 0rem;
    justify-items: center;
  }
`;

const ItemIcon = styled(Image)`
  width: 94px;
  height: 106px;
  position: absolute;
  bottom: 30px;
  @media (max-width: 1000px) {
    width: 80px;
    height: 90px;
    margin-bottom: 2rem;
  }
`;

const ItemContent = styled.div``;

const ItemTitle = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 1000px) {
    text-align: center;
  }
`;

const ItemDescription = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  margin-top: 0px;
  margin-bottom: 2.5rem;
  font-weight: normal;
  text-align: left;
  max-width: 550px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #54586b;
  @media (max-width: 1000px) {
    text-align: center;
    position: relative;
    bottom: 90px;
    font-size: 15px;
  }
`;

const ItemContainerG = styled.div`
  display: grid;
  align-items: center;
  width: 50%;
  @media (max-width: 1280px) {
    width: 40%;
  }
  margin-left: 3rem;
  grid-template-columns: 78px auto;
  grid-gap: 35px;

  @media (max-width: 1000px) {
    width: 100%;
    justify-self: center;
    grid-template-columns: auto;
    margin-left: 0rem;
    justify-items: center;
  }
`;

const ItemIconG = styled(Image)`
  max-width: 78px;
  @media (max-width: 1000px) {
    width: 100%;
    max-width: 128px;
  }
`;

const ItemContentG = styled.div``;

const ItemTitleG = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  text-align: left;
  line-height: normal;
  letter-spacing: normal;
  color: #26315c;
  @media (max-width: 1000px) {
    text-align: center;
  }
`;

const ItemDescriptionG = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  margin-top: 4px;
  font-weight: normal;
  text-align: left;
  max-width: 343px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #54586b;
  @media (max-width: 1000px) {
    text-align: center;
  }
`;

const SectionTwoG = styled(SectionParent)`
  background-repeat: no-repeat;
  background-image: linear-gradient(to bottom, #fafbfe 0%, #fafbfe 99%);
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  min-height: 400px;
  padding-top: 5rem !important;
  text-align: center;
  align-content: center;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
  grid-gap: 58px 0rem;
`;

const SectionOneG = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #745dbe;
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  margin-top: 6rem !important;
  padding-top: 5rem !important;
  min-height: 400px;
  text-align: center;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1000px) {
    min-height: 200px;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
  align-content: center;
`;

const HeroTitleG = styled(H1)`
  margin-left: 2.5rem;
  color: #e1e1e1;
  @media (min-width: 1280px) {
    font-size: 36px;
  }
  width: 50%;
  text-align: left;
  @media (max-width: 1280px) {
    width: 40%;
  }
  @media (max-width: 1000px) {
    width: 100%;
    text-align: center;
  }
  @media (max-width: 768px) {
    margin-left: 0rem;
    text-align: center;
  }
  @media (max-width: 520px) {
    font-size: 26px;
  }
`;

const HeroSubTitleG = styled.div`
  padding-top: 2rem;
  margin-left: 2.5rem;
  width: 50%;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #dfdfdf;
  @media (max-width: 1280px) {
    width: 40%;
  }
  @media (max-width: 768px) {
    text-align: center;
    width: 80%;
    margin-left: 0rem;
  }

  @media (max-width: 1000px) {
    width: 100%;
    text-align: center;
  }
`;

export default (props: any) => (
  <StaticQuery
    query={graphql`
      query {
        andi: file(relativePath: { eq: "v2/png/andi-laptop@3x.png" }) {
          childImageSharp {
            fluid(quality: 95) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }

        denso: file(relativePath: { eq: "v2/png/denso@3x.png" }) {
          childImageSharp {
            fluid(quality: 95) {
              aspectRatio
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }
      }
    `}
    render={(data: any) => (
      <>
        {props.messages.locale !== 'de' ? (
          <div style={{ position: 'relative' }}>
            <SectionOne id="section-one-kiosk">
              <HeroTitle>{props.messages?.DemoPageTitle}</HeroTitle>
              <HeroSubTitle>{props.messages?.DemoPageDesc1}</HeroSubTitle>
              <HeroSubTitle style={{ fontWeight: 900 }}>
                {props.messages?.DemoPageSubTitle1}
              </HeroSubTitle>
              <FormComponentList>
                <FormComponentListItem>
                  {props.messages?.DemoPageBullet1}
                </FormComponentListItem>
                <FormComponentListItem>
                  {props.messages?.DemoPageBullet2}
                </FormComponentListItem>
                <FormComponentListItem>
                  {props.messages?.DemoPageBullet3}
                </FormComponentListItem>
                <FormComponentListItem>
                  {props.messages?.DemoPageBullet4}
                </FormComponentListItem>
                <FormComponentListItem>
                  {props.messages?.DemoPageBullet5}
                </FormComponentListItem>
              </FormComponentList>
            </SectionOne>
            <RequestDemoForm
              messages={props.messages}
              endState={'/book-demo/submitted'}
            />
            <SectionTwo id="section-one-kiosk">
              <ItemContainer>
                <ItemIcon
                  loading="lazy"
                  fluid={data.andi.childImageSharp.fluid}
                  alt="Esper Andi"
                />
                <ItemContent>
                  <ItemDescription>
                    {props.messages?.DemoPageCommDesc}{' '}
                    <a href="mailto:andi@esper.io">andi@esper.io</a>{' '}
                    {props.messages?.DemoPageCommDesc2}
                  </ItemDescription>
                </ItemContent>
              </ItemContainer>
            </SectionTwo>
          </div>
        ) : (
          <div style={{ position: 'relative' }}>
            <SectionOneG id="section-one-kiosk">
              <HeroTitleG>{props.messages?.DemoPageTitle}</HeroTitleG>
              <HeroSubTitleG style={{ paddingTop: '1rem' }}>
                {props.messages?.DemoPageDesc1}
                <br />
                <br />
                {props.messages?.DemoPageDesc2}
              </HeroSubTitleG>
            </SectionOneG>
            <RequestDemoForm messages={props.messages} />
            <SectionTwoG id="section-one-kiosk">
              <ItemContainerG>
                <ItemIconG
                  loading="lazy"
                  fluid={data.andi.childImageSharp.fluid}
                  alt="Esper Andi"
                />
                <ItemContentG>
                  <ItemTitleG>{props.messages?.DemoPageComm}</ItemTitleG>
                  <ItemDescriptionG>
                    {props.messages?.DemoPageCommDesc}{' '}
                    <a href="mailto:andi@esper.io">andi@esper.io</a>
                  </ItemDescriptionG>
                </ItemContentG>
              </ItemContainerG>
              <ItemContainerG>
                <ItemIconG
                  loading="lazy"
                  fluid={data.denso.childImageSharp.fluid}
                  alt="Esper Andi"
                />
                <ItemContentG>
                  <ItemTitleG>{props.messages?.DemoPageSupport}</ItemTitleG>
                  <ItemDescriptionG>
                    {props.messages?.DemoPageSupportInfo}{' '}
                    <a href="mailto:support@esper.io">support</a>
                  </ItemDescriptionG>
                </ItemContentG>
              </ItemContainerG>
            </SectionTwoG>
          </div>
        )}
      </>
    )}
  />
);
